// src/components/PackingLists/ListHeader.js
import React from 'react';
import FormattedDate from '../FormattedDate';
import { Button } from 'react-bootstrap';

/**
 * ListHeader component displays the list title and trip type
 * Matches the UX of BikeHeader with static display and edit button
 * 
 * @param {Object} props - Component props
 * @param {Object} props.list - The list data object
 * @param {boolean} props.isOwner - Whether the current user is the list owner
 * @param {boolean} props.viewOnly - Whether the list is in view-only mode
 * @param {Function} props.handleEditPhoto - Function to handle edit button click
 * @returns {JSX.Element} Rendered component
 */
const ListHeader = ({ list, isOwner, viewOnly, handleEditPhoto }) => {
  return (
    <div className="listing-header-section">
      <div className={`listing-title-container ${isOwner ? 'editable' : ''}`}>
        <h2>{list.name}</h2>
        
        <div className="listing-meta">
          {list.tripType && (
            <div className="data">
              {list.tripType}
            </div>
          )}
          
          <div className="listing-timestamp">
            <span>Last updated: </span>
            <FormattedDate date={list.lastEdited} />
          </div>
        </div>
      </div>
      {isOwner && (
        <Button
            variant="secondary"
            onClick={handleEditPhoto}
        >
            Edit Details
        </Button>
      )}
      
      {viewOnly && (
        <div className="list-ownership-info">
          <div className="view-only-badge">Read-Only View</div>
          <div className="list-owner-info">
            {list.ownerName && (
              <>
                <span className="owner-label">Created by:</span>
                <div className="owner-details">
                  {list.ownerPhotoURL ? (
                    <img 
                      src={list.ownerPhotoURL} 
                      alt={`${list.ownerName}'s avatar`} 
                      className="owner-avatar"
                    />
                  ) : (
                    <div className="owner-avatar-placeholder">
                      {list.ownerName.charAt(0).toUpperCase()}
                    </div>
                  )}
                  <span className="owner-name">{list.ownerName}</span>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ListHeader;